import LoginOptionsModal from './LoginOptionsModal.container';

export default LoginOptionsModal;
